import { Pipe, PipeTransform } from "@angular/core";
import { StaffData } from "../../providers/staff";

@Pipe({
  name: "staff",
})
export class StaffPipe implements PipeTransform {
  constructor(private staffData: StaffData) { }

  public transform(idStaff: string, idClient: string, eventId: string) {
    return this.staffData.getStaffByStaffId(idClient, idStaff, eventId);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/staff/staff.ts